<template>
  <b-card
    title="مدیریت سوالات متداول"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 ml-1"
                variant="primary"
                :to="{ name: 'addfaq'}"
              >
                جدید
              </b-button>
              <b-button
                  variant="success"
                  class="mb-1 mr-auto ml-1"
                  @click="clearCache"
              >
                بروزرسانی
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="دسته بندی"
                    label-for="FaqCategoryId">
                  <z-faq-category
                      v-model="filterOptions.FaqCategoryId"
                      :multiple="false"
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatefaq', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(FaqCategory)="data">
            <b-badge
                variant="info"
            >
              {{ data.value.Title }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updatefaq', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon

                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

import ZFaqCategory from '@/tools/faqcategory.vue'

export default {
  name: 'Faq',
  components: {
    ZFaqCategory,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
        FaqCategoryId: null,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },

        {
          key: 'Title',
          label: 'عنوان',
          sortable: true,
        },
        {
          key: 'FaqCategory',
          label: 'دسته بندی',
        },
        {
          key: 'Like',
          label: 'لایک',
          sortable: true,
        },
        {
          key: 'Dislike',
          label: 'دیسلایک',
          sortable: true,
        },
        {
          key: 'Sort',
          label: 'ترتیب',
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        if (this.filterOptions.SortBy === 'Sort') {
          this.filterOptions.SortBy = 'Priority'
        }
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.faq.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearCache() {
      this.loading = true

      this.$http.post(
          this.$api.faq.clearcache, null,
      )
          .then(res => {
            this.update()
          })
    },
    remove(id) {
      this.removeRow(this.$api.faq.remove, 'Id', id)
    },
  },
}
</script>
